import { Fragment, useEffect, useState } from "react";
import ModalComponent from "../modal";
import InputComponent from "../input";
import CheckboxRadioComponent from "../checkbox-radio";
import SelectDropdownSecondaryComponent from "../select-dropdown-secondary";
import ButtonComponent from "../button";
import { useFormik } from "formik";
import { apiConfigurationFieldSchema, apiConfigurationFieldWithOTPSchema } from "../../helpers/schemas";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import { ActionsContainer, FieldContainer, Form, FormError, Label } from "./add-update-api-configuration-fields-modal.style";
import { useSelector } from "react-redux";
import { fieldTypesConstant, fieldTypesOptions } from "../../constants/app-constants";

const AddUpdateApiConfigurationFieldsModal = ({ data, close, label, step, parent, update, viewOnly, handleConfigurationSubmit}) => {
    const location = useLocation();
    const { apiConfigApiTypeOptions, apiConfigAttributeNameOptions, apiConfigOtpValidityOptions } = useSelector((state) => state.apiConfigReducer);

    const isChecker = location.pathname.includes('checker');
    const isDisabledAll = isChecker || viewOnly;

    const [hasChanges, setHasChanges] = useState(false);

    const { handleChange, handleBlur, handleSubmit, setFieldValue, setErrors, setFieldTouched, values, touched, errors, dirty } = useFormik({
        initialValues: data,
        validationSchema: step === 2 ? apiConfigurationFieldWithOTPSchema({ isChecker }) : apiConfigurationFieldSchema({ isChecker }),
        onSubmit: (e) => {
            if (hasChanges) {
                if ( (parent.some(p => parseInt(p?.ordering) === parseInt(e?.ordering))) && (parseInt(data?.ordering) !== parseInt(e?.ordering)) ) {
                    toast.error('Ordering already exists');
                    setErrors({ ordering: 'Ordering already exists' });
                } else {
                    handleConfigurationSubmit(e);
                }
            } else {
                toast.info('No changes found');
            }
        }

    });

    const handleNumberInput = (e) => {
        // Replace non-digits with empty string
        let value = e.target.value.replace(/[^0-9]/g, '');
        // Remove leading zeros unless the value is just "0"
        value = value.replace(/^0+(?=\d)/, '');
        e.target.value = value;
    };

    const fields = [
        {
            label: 'API Name',
            type: 'text',
            placeholder: 'Enter API name',
            name: 'apiName',
            value: values?.apiName,
            disabled: true,
        },
        {
            label: 'API Type',
            type: 'select',
            options: apiConfigApiTypeOptions,
            name: 'apiType',
            value: values?.apiType,
            disabled: isDisabledAll,
        },
        {
            label: 'Attribute Name Field',
            type: 'select',
            options: fieldTypesOptions,
            name: 'attributeField',
            value: values?.attributeField,
            handleCustomChange: (e) => {
                if (e?.value === fieldTypesConstant?.dropdown) {
                    setFieldValue('attributeName', '');
                }
            },
            disabled: isDisabledAll,
        },
        {
            label: 'Attribute Name',
            type: 'select',
            options: apiConfigAttributeNameOptions,
            name: 'attributeName',
            value: values?.attributeName,
            disabled: isDisabledAll,
            hide: values?.attributeField !== fieldTypesConstant?.dropdown,
        },
        {
            label: 'Attribute Name',
            type: 'text',
            placeholder: 'Enter attribute name',
            name: 'attributeName',
            value: values?.attributeName,
            disabled: isDisabledAll,
            hide: values?.attributeField !== fieldTypesConstant?.text,
        },
        {
            label: 'Date/Time Format',
            type: 'checkbox',
            innerLabel: 'Date/Time Format?',
            name: 'isDatetimeField',
            value: values?.isDatetimeField,
            disabled: isDisabledAll,
        },
        {
            label: 'Attribute Value',
            type: 'text',
            placeholder: 'Enter attribute value',
            name: 'attributeValue',
            value: values?.attributeValue,
            disabled: isDisabledAll,
        },
        {
            label: 'Ordering',
            type: 'text',
            placeholder: 'Set ordering',
            onInput: handleNumberInput,
            name: 'ordering',
            value: values?.ordering,
            handleCustomChange: async (e) => {
                if (parent.some(p => parseInt(p?.ordering) === parseInt(e?.value)) && (parseInt(data?.ordering) !== parseInt(e?.value))) {
                    await setFieldTouched('ordering', true, true);
                    setErrors({ ordering: 'Ordering already exists' });
                }
            },
            disabled: isDisabledAll,
        },
        // ...(isotpDeliveryShown ? [{
        //     label: 'OTP Delivery',
        //     type: 'select',
        //     options: apiConfigOtpValidityOptions,
        //     name: 'otpDelivery',
        //     value: values?.otpDelivery,
        //     disabled: isDisabledAll,
        // }] : []),
        {
            label: 'OTP Delivery',
            type: 'select',
            options: apiConfigOtpValidityOptions,
            name: 'otpDelivery',
            value: values?.otpDelivery,
            disabled: isDisabledAll,
            hide: step !== 2,
        },
        {
            type: 'action',
            actions: [
                { label: viewOnly ? 'Close' : 'Cancel', type: 'button', outline: !viewOnly, action: close },
                ...(!viewOnly ? [{ label: 'Save', type: 'submit' }] : []),
            ],
            fullCol: true,
        },
    ];

    useEffect(() => {
        setHasChanges(dirty);
    }, [dirty]);

    return (
        <ModalComponent close={close} label={label} width={700}>
            {/* MODAL BODY */}
            <Form onSubmit={handleSubmit}>
                {
                    fields && fields.length > 0 && fields.map((field, index) => (
                        <Fragment key={index}>
                            {
                                ['text', 'date', 'datetime-local', 'number'].includes(field.type) && !field.hide &&
                                <FieldContainer $fullcol={field.fullCol}>
                                    {/* <Label>{field.label}</Label> */}
                                    <InputComponent
                                        type={field.type}
                                        label={field.label}
                                        placeholder={field.placeholder}
                                        onBlur={handleBlur}
                                        onInput={field.onInput}
                                        name={field.name}
                                        value={field.value}
                                        min={field?.min}
                                        // onChange={handleChange}
                                        onChange={(e) => { handleChange(e); field?.handleCustomChange && field?.handleCustomChange(e?.target) }}
                                        disabled={field.disabled}
                                        mui
                                    />
                                    {
                                        touched[field.name] && errors[field.name] && (
                                            <FormError>{errors[field.name]}</FormError>
                                        )
                                    }
                                </FieldContainer>
                            }

                            {
                                field.type === 'select' && !field.hide &&
                                <FieldContainer $fullcol={field.fullCol}>
                                    {/* <Label>{field.label}</Label> */}
                                    <SelectDropdownSecondaryComponent
                                        label={field.label}
                                        options={field.options}
                                        name={field.name}
                                        value={field.value}
                                        onBlur={handleBlur}
                                        onChange={(e) => { handleChange(e); field?.handleCustomChange && field?.handleCustomChange(e?.target) }}
                                        // onChange={handleChange}
                                        disabled={field.disabled}
                                        mui
                                    />
                                    {
                                        touched[field.name] && errors[field.name] && (
                                            <FormError>{errors[field.name]}</FormError>
                                        )
                                    }
                                </FieldContainer>
                            }

                            {
                                ['checkbox', 'radio'].includes(field.type) && !field.hide &&
                                <FieldContainer $fullcol={field.fullCol}>
                                    <Label>{field.label}</Label>
                                    <CheckboxRadioComponent
                                        type={field.type}
                                        label={field.innerLabel}
                                        name={field.name}
                                        checked={field.value}
                                        onBlur={handleBlur}
                                        onChange={(e) => setFieldValue(field.name, e.target.checked)}
                                        disabled={field.disabled}
                                    />
                                    {
                                        touched[field.name] && errors[field.name] && (
                                            <FormError>{errors[field.name]}</FormError>
                                        )
                                    }
                                </FieldContainer>
                            }

                            {
                                field.type === 'action' && field.actions.length > 0 &&
                                <FieldContainer $fullcol={field.fullCol}>
                                    <ActionsContainer>
                                        {
                                            field.actions.map((button, index) => (
                                                <ButtonComponent key={index} label={button.label} type={button.type} outline={button.outline} color={button.color} onClick={button.action} />
                                            ))
                                        }
                                    </ActionsContainer>
                                </FieldContainer>
                            }
                        </Fragment>
                    ))
                }
            </Form>
        </ModalComponent>
    );
};

export default AddUpdateApiConfigurationFieldsModal;